module.exports = __webpack_public_path__ + "media/images/location--dc-40ad37406acd9f88edde327283eaee83.jpg";